<template>
  <em class="price-losenge"><pu-price :price="price" /></em>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { MoneyType as Money } from '~/utility/money'

@Component
class PuPriceLosenge extends Vue {
  @Prop({ required: true })
  price: Money
}

export default toNative(PuPriceLosenge)
</script>

<style scoped>
.price-losenge {
  font-weight: bold;
  white-space: nowrap;
}
</style>
